/**
 * combat module entry (owner: combat-builder).
 *
 * Integration:
 *   - `runBattle(from, 'sword-training')` from a cinematic `battle` step (src/cinematics/SceneHost.ts
 *     already calls it): registers BattleScene on first use, fades out, pauses the caller, launches the
 *     bout, resumes the caller and resolves with the BattleOutcome ('goal' | 'rounds' | 'downed').
 *   - `registerShowcase()` (src/core/wiring.ts hook) adds `?showcase=combat`.
 *   - Data: src/content/combat/sword-training.json (BattleConfig + tutorial extensions in ./types.ts).
 */
import { SHOWCASES } from '@/content/ShowcaseScene';
import { combatShowcase } from './showcase';

export { BATTLES, registerBattles, getBattle, SWORD_TRAINING } from './registry';
export { BattleEngine, simulate, normaliseConfig } from './engine';
export type { ActorState, BattleEvent, ActionView, EngineSnapshot, Intent } from './engine';
export { BattleScene } from './BattleScene';
export type { BattleDebugHook } from './BattleScene';
export { DEFAULT_RULES } from './types';
export type { SwordTrainingConfig, BattleRules, BattleActionSpec, BattleScriptEntry, BattleSpriteSpec, BattleLaunchData, TutorAiConfig, TutorMove } from './types';
export { ensureBattleSprite, ensureBattleBackground, battleAnimKey, battleFrameName, BATTLE_ANIMS } from './devSprites';
export { playFx, ensureFx, floatText, fxAnimKey } from './fx';
export { runBattle, battleSeed } from './runBattle';
export type { RunBattleOptions } from './runBattle';

/** Registers `?showcase=combat`. Called by the integrator through src/core/wiring.ts. */
export function registerShowcase(): void {
  SHOWCASES['combat'] = combatShowcase;
}
